import { format, addDays, addMinutes } from 'date-fns'
import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

let sort_ = (schedules) => schedules.sort((a, b) => new Date(a.start) - new Date(b.start))
// eslint-disable-next-line no-unused-vars
let sort_end = (schedules) => schedules.sort((a, b) => new Date(a.end) - new Date(b.end) )
let date_ = (datetime) => datetime.split(' ')[0]
let time_ = (datetime) => datetime.split(' ')[1]
const date_range = (start, end) => moment.range(moment(start, 'YYYY-MM-DD'), moment(end, 'YYYY-MM-DD'))
const datetime_range = (start, end) => moment.range(moment(start, 'YYYY-MM-D HH:mm:ss'), moment(end, 'YYYY-MM-D HH:mm:ss'))
const appendToDate = (date, m, a, s, e, r) => {
  var schedule = {
        start: `${date} ${s}`,
        end: `${date} ${e}`
      },
      rtrn = [ ...r ]
  if (!m) schedule.schedule = { ...a }
  var exist = rtrn.find(el => el.date === date) || false
  var schedules_ = exist.schedules || []
  schedules_.push({ ...schedule })
  let new_ = { date, schedules: schedules_ }
  if (exist) {
    exist = new_
  } else {
    rtrn.push(new_)
  }
  return rtrn
}
const appendToDateTime = (employee, datetime, duration, color, r) => {
  var rtrn = [ ...r ],
      exist = rtrn.find(el => el.datetime === datetime) || false,
      av_employees = exist.av_employees || []
  av_employees.push(employee)
  let end = format(addMinutes(new Date(datetime), parseInt(duration)), 'yyyy-MM-dd HH:mm:ss'),
      new_ = {
        UUID: getRandomUnique(),
        datetime,
        date: date_(datetime),
        time: time_(datetime),
        duration: parseInt(duration),
        start: datetime,
        end,
        av_employees,
        color
      }
  if (exist) {
    exist = new_
  } else {
    rtrn.push(new_)
  }
  return rtrn
}
const getRandomUnique = () => {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

export class Scheduler {
  constructor (employees, schedules, filters, others = [], UUID = '') {
    this.config = {
      date_range: 1,
      time_step: 30,
      min_duration: 30,
      office: {
        start: '09:00:00',
        end: '20:00:00'
      }
    }
    // this.employees = [ ...employees ]
    this.employees = (filters.employees.length > 0 && filters.match ? [ ...filters.employees ] : [ ...employees ])
    this.schedules = [ ...schedules ]
    this.filters = { ...filters }
    this.others = [ ...others ]
    this.self = (UUID !== '' && UUID !== null ? UUID : false)
    this.duration = (parseInt(filters.duration) > this.config.min_duration ? parseInt(filters.duration) : this.config.min_duration)
  }

  /* INTERNAS */
  _roundTimeQuarter (time) {
    time.setMilliseconds(Math.round(time.getMilliseconds() / 1000) * 1000)
    time.setSeconds(Math.round(time.getSeconds() / 60) * 60)
    time.setMinutes(Math.round(time.getMinutes() / this.config.time_step) * this.config.time_step)
    return time
  }

  _getSlotDateColor (datetime) {
    let start = moment(),
        end = moment(datetime, 'YYYY-MM-D HH:mm:ss'),
        diff_ = moment.duration(end.diff(start)),
        diff = Math.floor(diff_.asDays())
    switch (true) {
      case diff <= 7:
        return 'green'
      case diff <= 30:
        return 'amber'
      case diff > 30:
        return 'red'
      default:
        return 'grey'
    }
  }

  _mergeSlots (slots) {
    for (let i = slots.length - 1; i--;) {
      let curr = slots[i];
      let next = slots[i + 1];
      
      if (time_(curr.start) === '00:00:00' && time_(next.end) === '23:59:59') {
        let start = new Date(curr.start),
            end = new Date(next.end),
            diff = end.getTime() - start.getTime(),
            duration = Math.floor(diff / 60000)

        slots[i] = { start: format(start, 'yyyy-MM-dd HH:mm:ss'), end: format(end, 'yyyy-MM-dd HH:mm:ss'), duration }
        slots.splice(i + 1, 1)
      }
    }
    // console.log('_mergeSlots', slots)
    return slots
  }

  _mergeOverlaps (schedules) {
    return schedules.map((date) => {
      // DIVIDIR EM DEGRAUS
      let quartered = (date.schedules || []).reduce((add, val) => {
        let quarters = Array.from(
              datetime_range(val.start, val.end).by('minutes', { step: this.config.time_step })
            )
            .map(rng => ({
              start: rng.format('YYYY-MM-DD HH:mm:ss'),
              end: rng.add(this.config.time_step, 'minutes').format('YYYY-MM-DD HH:mm:ss')
            }))
        return sort_(add.concat(quarters))
      }, [])

      // REMOVER DUPLICADOS COM CONTADOR
      quartered = quartered.reduce((add, val) => {
        let exist = add.find(ext => ext.start === val.start) || false
        if (exist) {
          exist.count = parseInt(exist.count + 1)
        } else {
          add.push({
            start: val.start,
            end: val.end,
            count: 1
          })
        }
        return add
      }, [])

      // UNIR DIVISÕES QUE COMBINAM EM UM
      quartered = quartered.reduce((add, curr) => {
        let same = add.find(prev => prev.end === curr.start && prev.count === curr.count) || false
        if (same) {
          same.end = curr.end
        } else {
          add.push({
            start: curr.start,
            end: curr.end,
            count: curr.count
          })
        }
        return add
      }, [])

      // console.log('quartered to ' + date.date, quartered)
      date.schedules = [ ...quartered ]
      return date
    })
  }

  _filterClosed (schedules) {
    return schedules.map((date) => {
      date.schedules = date.schedules.filter(quar => quar.count >= this.filters.limit)
      return date
    })
  }

  _getClosedSlots (min = true, full = false) {
    var employees = [ ...this.employees ],
        schedules = [ ...this.schedules ].filter(sch => sch.status <= 1 && (!this.self || sch.root !== this.self)),
        closed = []
    if (!full) schedules = schedules.filter(sch => moment(sch.end).isSameOrAfter())
    //console.log('filtered schedules', schedules)
    closed = employees.map((emp) => {
      var schedules_ = schedules
            .filter(sch => (sch.employees || [])
              .findIndex(emp_ => emp_ === emp.id) >= 0
            ),
          others = (this.others || [])
            .filter(sch => (sch.employees || [])
              .findIndex(emp_ => emp_ === emp.id) >= 0
              && typeof sch.saved === 'undefined'
            ),
      rtrn = []
      schedules_ = schedules_.concat(others)
      schedules_ = sort_(schedules_) || []
      // console.log('_getClosedSlots > schedules to ' + emp.name, schedules_)
      schedules_.forEach(a => {
        let days = Array.from(
          date_range(
            date_(a.start),
            date_(a.end)
          ).by('day')
        ).map(el => format(new Date(el), 'yyyy-MM-dd'))
        days.forEach((date, i_) => {
          let start = (i_ === 0 ? time_(a.start) : '00:00:00'),
              end = (i_ === (days.length - 1) ? time_(a.end) : '23:59:59')
          rtrn = appendToDate(date, min, a, start, end, rtrn)
        })
      }, []) || []
      rtrn = this._mergeOverlaps(rtrn)
      rtrn = this._filterClosed(rtrn)
      return {
        employee: { ...emp },
        schedules: [ ...rtrn ]
      }
    }) || []
    //console.log('closedSlots', closed)
    return closed
  }

  _getOpenedSlots (date = false) {
    let closedSlots = JSON.parse(JSON.stringify([ ...this._getClosedSlots() ])),
        rtnr = []

    if (date && typeof date === 'string') {
      var [ year, month, day ] = [ ...date.split("-") ]
      month = month - 1
    }

    closedSlots.forEach(emp => {
      var slots = [],
          employee = { ...emp.employee },
          schedules = [ ...emp.schedules ]
      let date_s = (date ? date : format(new Date(), 'yyyy-MM-dd')),
          date_e = (date ? format(addDays(new Date(year, month, day), this.config.date_range), 'yyyy-MM-dd') : format(addDays(new Date(), this.config.date_range), 'yyyy-MM-dd')),
          dates = Array.from(
            date_range(date_s, date_e).by('day')
          ).map(el => format(new Date(el), 'yyyy-MM-dd'))

      dates.forEach(date => {
        let find = schedules.find(sch => sch.date === date) || false,
            startTime = `${date} ${(this.filters.office_hour ? this.config.office.start : '00:00:00')}`,
            endTime = `${date} ${(this.filters.office_hour ? this.config.office.end : '23:59:59')}`
        // console.log('open slots time', { startTime, endTime })
        find = (find ? { ...find } : false)
        var schedules_ = (find.schedules || []).filter(sch => new Date(sch.end) > new Date(startTime))
        schedules_ = schedules_.map((sch) => {
          if (new Date(sch.start) < new Date(startTime)) sch.start = startTime
          if (new Date(sch.end) > new Date(endTime)) sch.end = endTime
          return sch
        })
        schedules_ = sort_(find.schedules || [])
        // console.log('date each schedules for ' + employee.name, schedules_)
        if (schedules_.length > 0) {
          let first = schedules_[0] || false,
              last = schedules_[(schedules_.length - 1)] || false
          if (first && new Date(first.start) > new Date(startTime)) schedules_.unshift({ start: startTime, end: startTime })
          if (last && new Date(last.end) < new Date(endTime)) schedules_.push({ start: endTime, end: endTime })
          // console.log('schedules_', schedules_)
          schedules_.forEach((curr, i) => {
            let prev = schedules_[i - 1]
            if (i > 0) {
              let start = new Date(prev.end),
                  end = new Date(curr.start),
                  diff = end.getTime() - start.getTime(),
                  duration = Math.floor(diff / 60000)
              slots.push({ start: format(start, 'yyyy-MM-dd HH:mm:ss'), end: format(end, 'yyyy-MM-dd HH:mm:ss'), duration })
            }
          })
        } else {
          let start = new Date(startTime),
              end = new Date(endTime),
              diff = end.getTime() - start.getTime(),
              duration = Math.floor(diff / 60000)
          slots.push({ start: format(start, 'yyyy-MM-dd HH:mm:ss'), end: format(end, 'yyyy-MM-dd HH:mm:ss'), duration })
        }
      })
      if (!this.filters.office_hour) slots = this._mergeSlots(slots)
      rtnr.push({ employee, slots })
    })
    //console.log('openedSlots', rtnr)
    return rtnr
  }

  _preparedSlots (duration, date = false) {
    var openedSlots = JSON.parse(JSON.stringify([ ...this._getOpenedSlots(date) ])),
        rtrn = [],
        now = new Date(),
        time = (this.filters.time ? `${this.filters.time}:00` : false)

    const quarterSlots = openedSlots.map(emp => {
      let slots_ = emp.slots || [],
          slots = slots_.filter(slot => slot.duration >= duration),
          dates = Array.from(
            new Set(
              slots.reduce((a, slot) => {
                a.push(date_(slot.start))
                a.push(date_(slot.end))
                return a
              }, [])
            )
          ),
          lastDate = (dates.length > 1 ? dates[(dates.length - 1)] : false)
      var quarters = slots.map(slot => {
        // console.log('each slots from ' + emp.employee.name, slot)
        let start = (new Date(slot.start) >= now ? slot.start : format(this._roundTimeQuarter(now), 'yyyy-MM-dd HH:mm:ss')),
            quarters_ = Array.from(
              datetime_range(start, slot.end).by('minutes', { step: this.config.time_step })
            ).map(rng => rng.format('YYYY-MM-DD HH:mm:ss'))
        // console.log('quarters from ' + date_(slot.start), quarters_)
        return quarters_.filter(quarter => {
          let start_ = new Date(quarter),
              end_ = new Date(slot.end),
              diff = end_.getTime() - start_.getTime(),
              toEnd = Math.floor(diff / 60000)
          // console.log('quarter ' + quarter, { duration, toEnd })
          // console.log('quarter ' + quarter, { start: date_(start), curr: date_(quarter) })
          return (duration <= toEnd && (!lastDate || lastDate !== date_(quarter)) && (!time || time === time_(quarter)))
        })
      })
      // console.log('quarters', { employee: emp.employee, quarters })
      return { employee: emp.employee, quarters }
    })
    // console.log('_preparedSlots', quarterSlots)
    rtrn = [ ...quarterSlots ]
    return rtrn
  }

  _getAvailable (date) {
    let rtrn = [],
        duration = this.duration || this.config.min_duration
    const openSlots = this._preparedSlots(duration, date),
          flatten = openSlots.map(emp => {
            let quarters = emp.quarters || []
            emp.quarters = quarters.reduce((a, v) => a.concat(v), [])
            return emp
          })
    flatten.forEach(emp => {
      let slots = emp.quarters || []
      slots.forEach(slot => {
        let color = this._getSlotDateColor(slot)
        rtrn = appendToDateTime(emp.employee, slot, duration, color, rtrn)
      })
    })
    if ((this.filters.employees || []).length > 0) {
      rtrn = rtrn.filter(slot => (!this.filters.match || (slot.av_employees || []).length === this.filters.employees.length) && (this.filters.match || (this.filters.employees || []).every(emp => (slot.av_employees || []).findIndex(emp_ => emp_.id === emp.id) >= 0)))
    }
    return rtrn.sort((a, b) => new Date(a.datetime) - new Date(b.datetime))
  }

  /* ... */

  available (start) {
    let rtrn = [],
        count = 0,
        startDate = (start ? start : format(new Date(), 'yyyy-MM-dd')),
        date = (this.filters.date ? this.filters.date : startDate)

    while (rtrn.length <= 7) {
      let search = this._getAvailable(date)
      if (search) {
        rtrn = rtrn.concat(search)
        date = format(addDays(new Date(Date.parse(date.replace('-','/','g'))), 1), 'yyyy-MM-dd')
      }
      count++
      if (this.filters.date || rtrn.length >= 7 || count >= 52) break;
    }
    return rtrn
  }

}
